module.exports = __webpack_public_path__ + "static/media/SM-ST2-TRIAL-if-correct.7f50e713.mp3";